document.addEventListener('DOMContentLoaded', function () {
  // Select all feature bar elements. We'll check for 'has-marquee' inside the loop.
  const featureBars = document.querySelectorAll('.js-feature-bar');

  featureBars.forEach((bar) => {
    // Determine if marquee logic should apply by checking for the 'has-marquee' class
    const isMarquee = bar.classList.contains('has-marquee');

    const updateFeatureBar = () => {
      const containers = bar.querySelectorAll('.js-marquee-container');

      containers.forEach((container) => {
        // Only apply marquee logic if 'has-marquee' class is present
        if (isMarquee) {
          const inner = container.querySelector('.js-marquee-content');

          // Remove old duplicates
          const duplicates = container.querySelectorAll('.js-marquee-duplicate');
          duplicates.forEach((duplicate) => {
            duplicate.remove();
          });

          // Force reflow
          // Assign to a variable to trigger a reflow.
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const forceReflowDummy = container.offsetHeight;

          if (inner.scrollWidth > container.clientWidth) {
            container.classList.add('is-scrollable');

            const featureItems = inner.querySelectorAll('.feature-bar__features-item:not(.js-marquee-duplicate)');
            featureItems.forEach((item) => {
              const duplicate = item.cloneNode(true);
              duplicate.classList.add('js-marquee-duplicate');
              duplicate.setAttribute('aria-hidden', 'true');
              inner.appendChild(duplicate);
            });

            const contentWidth = inner.scrollWidth;
            const duration = Math.max(15, contentWidth / 100);
            container.style.setProperty('--scroll-duration', `${duration}s`);
          } else {
            container.classList.remove('is-scrollable');
          }
        } else if (container.scrollWidth > container.clientWidth) {
          container.classList.add('is-scrollable');
        } else {
          container.classList.remove('is-scrollable');
        }
      });
    };

    // Initial run for this specific feature bar instance
    updateFeatureBar();

    // Resize handling (debounced) for this specific feature bar instance
    let resizeTimeout;
    const resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateFeatureBar, 100);
    };
    window.addEventListener('resize', resizeHandler);
  });
});
